import { render, staticRenderFns } from "./cards-list-item-aliment.vue?vue&type=template&id=68265659&scoped=true&"
import script from "./cards-list-item-aliment.vue?vue&type=script&lang=js&"
export * from "./cards-list-item-aliment.vue?vue&type=script&lang=js&"
import style0 from "./cards-list-item-aliment.vue?vue&type=style&index=0&id=68265659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68265659",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VList,VListItem,VListItemTitle,VMenu,VTooltip})
